import { memo } from 'react';
import { useSelector } from 'react-redux';

import { ImageUpIcon } from '@air/design-icons';

import { searchFieldIconSlot } from '~/components/Search/searchFieldChrome';
import { ClipSearch } from '~/components/SearchCommand/SmartSearchImageSearchStatus/ClipSearch';
import { ImageUploadSearch } from '~/components/SearchCommand/SmartSearchImageSearchStatus/ImageUploadSearch';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { similarToImageFilterSelector } from '~/store/filters/selectors';

export const SmartSearchImageSearchStatus = memo(() => {
  // Read from Redux for similarToImage (not in URL due to base64 size)
  const similarToImage = useSelector(similarToImageFilterSelector);

  // Read from URL for similarTo (URL is the source of truth)
  const { semanticClipSearchParam } = useFilterParams();
  const similarTo = semanticClipSearchParam?.is;

  if (!similarToImage && !similarTo) {
    return null;
  }

  return (
    <div className="flex h-full min-w-0 items-center gap-1.5" data-testid="SMART_SEARCH_IMAGE_SEARCH_STATUS">
      <span className={searchFieldIconSlot()}>
        <ImageUpIcon className="shrink-0 ads:text-icon-default text-gray-10" data-testid="SIMILAR_TO_ICON" size="sm" />
      </span>
      <span className="shrink-0 font-medium ads:text-primary text-14 text-gray-12" data-testid="SIMILAR_TO_LABEL">
        Similar to
      </span>
      {similarToImage ? <ImageUploadSearch similarToImage={similarToImage} /> : null}
      {!similarToImage && similarTo ? <ClipSearch clipId={similarTo} /> : null}
    </div>
  );
});

SmartSearchImageSearchStatus.displayName = 'SmartSearchImageSearchStatus';
